// extracted by mini-css-extract-plugin
module.exports = {"not-found-page":"not-found-page__37S_Q","message-box":"message-box__108zr"};